// extracted by mini-css-extract-plugin
export var avatarContainer = "_fh-0";
export var gray = "_fh-f";
export var green = "_fh-c";
export var icon = "_fh-9";
export var image = "_fh-1";
export var lg = "_fh-6";
export var md = "_fh-5";
export var presenceDot = "_fh-b";
export var red = "_fh-d";
export var sm = "_fh-4";
export var status = "_fh-a";
export var xl = "_fh-7";
export var xs = "_fh-3";
export var xxl = "_fh-8";
export var xxs = "_fh-2";
export var yellow = "_fh-e";